import icon from 'vue-svgicon';

icon.register({
    'regular/office-file-doc': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M4.5 19.5a3 3 0 0 0 3-3V15a3 3 0 0 0-3-3zM12 12a1.5 1.5 0 0 0-1.5 1.5V18a1.5 1.5 0 0 0 3 0v-4.5A1.5 1.5 0 0 0 12 12zM19.5 12a3 3 0 0 0-3 3v1.5a3 3 0 0 0 3 3" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" d="M22.81 5.559a1.5 1.5 0 0 1 .439 1.06V21A2.25 2.25 0 0 1 21 23.248H3A2.25 2.25 0 0 1 .749 21V3A2.25 2.25 0 0 1 3 .748h14.378a1.5 1.5 0 0 1 1.061.439z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="2" d="M17.249.748v4.5a1.5 1.5 0 0 0 1.5 1.5h4.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
